import type { ColorTag } from "@color-finder/color-finder-api/models";
import { Chip, Stack, Tooltip, Typography } from "@mui/material";

export interface ColorTagsDisplayProps {
  value: Array<ColorTag>;
}

function ColorTagsDisplay({ value }: ColorTagsDisplayProps) {
  return (
    <Stack flexWrap="wrap" gap={1} direction="row">
      {value.map((tag) => (
        <Tooltip
          arrow={true}
          key={tag.value}
          title={
            <>
              <Typography fontWeight={500} fontSize="1em">
                {tag.name}
              </Typography>
              <Typography fontSize="1em">{tag.description}</Typography>
            </>
          }
        >
          <Chip size="small" label={tag.name} />
        </Tooltip>
      ))}
    </Stack>
  );
}

export default ColorTagsDisplay;
